import React, { useEffect, useState } from 'react'
import Page from 'src/components/Page'
import { Container, Card, CardHeader, CardContent, Divider, Grid, Button, TextField, Table, TableContainer, TableHead, TableBody, TableCell, TableRow, TablePagination, Collapse, Snackbar, Skeleton, Box, Chip } from '@mui/material';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios'
import { getUser } from 'src/utils/Common'
import moment from 'moment'
import { useNavigate, useLocation } from 'react-router'

function MultipleReceiptInquiry() {
    const navigate = useNavigate();
    const location = useLocation();
    const SessionUser = getUser();

    const [totalReceiptNumber, setTotalReceiptNumber] = React.useState(0);
    const [receiptNumbers, setReceiptNumbers] = React.useState('');
    const [generalData, setGeneralData] = React.useState([]);

    const [isVisible, setIsVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    useEffect(() => {
        // Sayfa yüklendiğinde veya bileşen oluşturulduğunda önceki sayfa yolunu kontrol eder
        const previousPath = localStorage.getItem('previousPath');
        console.log(previousPath);
        if (previousPath === '/SarisQueries/ReceiptDetails') {
            setTotalReceiptNumber(Number(localStorage.getItem('totalReceiptNumber')) || 0);
            setReceiptNumbers(localStorage.getItem('receiptNumbers') || '');
            setGeneralData(JSON.parse(localStorage.getItem('generalData')) || []);
            setIsVisible(localStorage.getItem('isVisible') === 'true');
        }
    }, []);

    useEffect(() => {
        // Durum (state) değerleri değiştiğinde yerel depolamaya kaydedilir
        localStorage.setItem('totalReceiptNumber', totalReceiptNumber);
        localStorage.setItem('receiptNumbers', receiptNumbers);
        localStorage.setItem('generalData', JSON.stringify(generalData));
        localStorage.setItem('isVisible', isVisible);

        // Geçerli sayfa yolunu yerel depolamaya kaydeder
        localStorage.setItem('previousPath', location.pathname);
    }, [totalReceiptNumber, receiptNumbers, generalData, isVisible]);

    const handleButtonClick = () => {
        if (receiptNumbers.length <= 0) {
            setresponseMessage('Lütfen Fiş Numarası alanını boş bırakmayınız!...');
            setUyariTip('warning');
            setUyari(true);
            return;
        }
        setIsVisible(true);
        const value = receiptNumbers;
        const commaSeparated = value.split('\n').filter(Boolean).join(',');
        getReceiptsData(commaSeparated);
    };

    const getReceiptsData = (commaSeparated) => {
        setLoading(true);
        axios.get(`GetMultipleReceiptList/${commaSeparated}`)
            .then((response) => {
                var data = Array.isArray(response.data) ? response.data : [];
                let counter = data.length;

                setTotalReceiptNumber(counter);
                setGeneralData(data);
                setPage(0);

                setLoading(false);
            }).catch((error) => {
                setLoading(false);
            });
    }

    const clearEverything = () => {
        setReceiptNumbers('');
        setGeneralData([]);
        setIsVisible(false);
    }

    const handleRowClick = (ReceiptNumber) => {
        navigate(`/SarisQueries/ReceiptDetails/${ReceiptNumber}`);
    }

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={5000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Page title={'Fiş Sorgu Toplu'}>
                <Container maxWidth="md">
                    <Card>
                        <CardHeader title="Toplu Fiş Listesi" />
                        <Divider />
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <TextField
                                        label='Fiş Numaraları'
                                        variant='outlined'
                                        fullWidth
                                        multiline
                                        minRows={10}
                                        value={receiptNumbers}
                                        onChange={(event) => { setReceiptNumbers(event.target.value); }}
                                        helperText="Fiş numaralarını her satıra bir fiş gelecek şekilde yazınız. (Ya da Excel'den column seçerek paste ediniz)"
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="outlined"
                                            color="secondary"
                                            onClick={() => { clearEverything(); }}
                                        >
                                            TEMİZLE
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => { handleButtonClick(); }}
                                        >
                                            GÖNDER
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Collapse in={isVisible}>
                        <Card sx={{ mt: 3 }}>
                            <CardHeader title={`Toplamda ${totalReceiptNumber} adet fiş bulundu`} />
                            <Divider />
                            <TableContainer>
                                <Table size='small'>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700 }}>Fiş Numarası</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Servis Kodu</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Çağrı Tarihi</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>İşlem Tarihi</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Ürün</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Başvuru Nedeni</TableCell>
                                            <TableCell sx={{ fontWeight: 700 }}>Durum</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ? (
                                            Array.from(new Array(3)).map((_, index) => (
                                                <TableRow key={index}>
                                                    {Array.from(new Array(7)).map((_, cellIndex) => (
                                                        <TableCell key={cellIndex} colSpan={1}>
                                                            <Skeleton animation="pulse" variant="text" />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : (
                                            generalData
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map((data, index) => (
                                                <TableRow key={index} hover>
                                                    <TableCell>
                                                        <Chip
                                                            label={data.FIS_NO}
                                                            size="small"
                                                            variant="outlined"
                                                            clickable
                                                            onClick={() => { handleRowClick(data.FIS_NO); }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{data.KUL_BIRIM_KODU}</TableCell>
                                                    <TableCell>{moment(data.CAGRI_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                                    <TableCell>{moment(data.ISLEM_TARIHI).format('DD-MM-YYYY HH:mm:ss')}</TableCell>
                                                    <TableCell>{data.ACIKLAMA}</TableCell>
                                                    <TableCell>{data.BASVURU_NEDENI}</TableCell>
                                                    <TableCell>{data.DURUM_ACIKLAMA}</TableCell>
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {!loading && (
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50]}
                                    component="div"
                                    count={generalData.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            )}
                        </Card>
                    </Collapse>
                </Container>
            </Page>
        </>
    );
}

export default MultipleReceiptInquiry
